import React, { memo, useRef, useEffect } from 'react'
import ReactHtmlParser from 'react-html-parser';
import Player from '@vimeo/player';
import Youtube from 'react-youtube';
import Vimeo from '@u-wave/react-vimeo';
import { getVideo } from '../helpers';

function VideoPlayer({ videoEmbed, onPlay }) {
  const playerRef = useRef(null);
  const wrapperRef = useRef(null);
  
  useEffect(() => {
    let player = null;
    
    // Verificação apenas para embeds diretos com iframe do Vimeo
    const timer = setTimeout(() => {
      const iframe = wrapperRef.current?.querySelector('iframe');
      const iframeUrl = iframe?.src || '';
      
      // Só cria o Player se for realmente um iframe do Vimeo
      if (iframe && !playerRef.current && iframeUrl.includes('vimeo.com')) {
        player = new Player(iframe);
        playerRef.current = player;
        player.on('play', onPlay);
      } else if (playerRef.current) {
        // Se o player já existe, apenas atualiza o listener
        playerRef.current.off('play');
        playerRef.current.on('play', onPlay);
      }
    }, 100);
    
    return () => {
      clearTimeout(timer);
      if (playerRef.current) {
        playerRef.current.off('play', onPlay);
      }
    };
  }, [onPlay]);

  const video = getVideo(videoEmbed);
  const videoId = video.id;

  // Renderizar o player de acordo com o tipo de vídeo
  switch(video.type) {
    case 'vimeo':
      return (
        <div className="video-wrapper">
          <Vimeo
            pip={true}
            responsive
            quality="540p"
            textTrack="pt"
            video={videoId}
            speed onPlay={onPlay}
          />
        </div>
      );
    case 'youtube':
      return (
        <div className="video-wrapper">
          <Youtube 
            videoId={videoId} 
            onPlay={onPlay} 
            opts={{
              playerVars: {
                rel: 0,
                showinfo: 0,
                modestbranding: 1,
              }
            }}
          />
        </div>
      );
    default:
      return (
        <div className="video-wrapper" ref={wrapperRef}>
          {ReactHtmlParser(videoEmbed)}
        </div>
      );
  }
}

export default memo(VideoPlayer)
